import { Box, useTheme } from '@mui/material';
import { ScholarshipCard } from '../../../../components/scholarship-card/ScholarshipCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ScholarshipListItem } from '../../../../types/scholarship';
import { SwiperOptions } from 'swiper';
import { featuredScholarshipsStyles } from './styles';

interface FeaturedScholarshipSliderProps {
  scholarships: ScholarshipListItem[];
}
export const FeaturedScholarshipSlider: React.FC<FeaturedScholarshipSliderProps> = ({ scholarships }) => {
  const theme = useTheme();
  const sliderBreakpoints: SwiperOptions['breakpoints'] = {
    [theme.breakpoints.values.sm * 16]: { slidesPerView: 2 },
    [theme.breakpoints.values.lg * 16]: { slidesPerView: 3 },
    [theme.breakpoints.values.xl * 16]: { slidesPerView: 4 },
  };
  return (
    <Box sx={featuredScholarshipsStyles.sliderContainer}>
      <Swiper className="featuredScholarshipsSlider" slidesPerView={1} breakpoints={sliderBreakpoints}>
        {scholarships.map((scholarship) => (
          <SwiperSlide key={scholarship.id}>
            <Box sx={{ pr: 2.5, height: 1 }}>
              <ScholarshipCard scholarship={scholarship} />
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};
